import CodeEditorStyles from '../NodeCodeEditor/NodeCodeEditor.module.scss';
import NodeAutomationStyles from '../NodeAutomation/NodeAutomation.module.scss';
import Styles from './seleniumEditor.module.scss';
import React, { useEffect, useState, useRef, useContext } from 'react';
import { useParams, useNavigate } from 'react-router';

// Module imports.
import _ from 'lodash';
import axios from 'axios';
import 'react-chat-widget/lib/styles.css';
import 'react-toastify/dist/ReactToastify.css';
import MonacoEditor from '@monaco-editor/react';
import { ToastContainer, toast } from 'react-toastify';
import { CodeBlock, anOldHope } from 'react-code-blocks';
import { Python3Parser } from 'dt-python-parser';
import quote from 'shell-quote/quote';
import parse from 'shell-quote/parse';

import {
	Avatar, Typography, Fab,
	LinearProgress, Box, Backdrop
} from '@mui/material';
import { pink } from '@mui/material/colors';
import InfoIcon from '@mui/icons-material/Info';
import TerminalIcon from '@mui/icons-material/Terminal';
import ViewInArIcon from '@mui/icons-material/ViewInAr';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';

// Components import.
import { decoder } from 'utils/helpers/decoder';
import { useAPI, AuthContext, Feedback, ViewContext } from 'components/lib';
import { NodeTimeline } from 'components/global/NodeLayout/NodeTimeline';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';
import { RenderFolderTree } from 'components/global/NodeLayout/CodeEditorComponents/FileTree';
import InfoDrawer from 'components/global/NodeLayout/InfoDrawer.js';
import { Joyride } from 'components/walkthrough/walkthrough';
import { HelperChat } from 'components/global/HelperChat/HelperChat';
import { BackConfirmationCard } from 'components/global/BackConfirmationCard/BackConfirmationCard';
import { LightTooltip } from 'components/global/NodeLayout/NodeTopostman';
import { TerminalPane } from 'components/global/NodeLayout/TerminalPane.js';
import { ConfirmationCard } from 'components/global/ConfirmationCard/ConfirmationCard.js';

//Util Imports
import { createSocketConnection, cleanupSocket } from 'views/CodeEditor/utils/socketService';

// Assets Import.
import failedAttemptSound from 'assets/sounds/try-again.mp3';
const finalAudio = `${process.env.REACT_APP_GLOBAL_MEDIA_URL}/media/git/voice/finish_node.mp3`;

const NodeEditorTerminal = (props) => {

	const navigate = useNavigate();
	const currentRef = useRef(null);
	const context = useContext(AuthContext);
	const { node_id } = useParams();
	const { lab_id } = useParams();
	const { resource } = useParams();

	const { data, loading } = useAPI(`/api/labs/${lab_id}/nodes/${node_id}/${resource}`, 'GET');

	const [watcherData, setWatcherData] = useState([]);
	const [isDrawerOpen, setIsDrawerOpen] = useState(false);
	const [nodeInfo, setNodeInfo] = useState(data);
	const [currentStep, setCurrentStep] = useState(0);
	const [steps, setSteps] = useState();
	const [userInput, setUserInput] = useState('');
	const [nodeFinished, setNodeFinished] = useState(false);
	const [isMuted, setIsMuted] = useState(true);
	const [editorCode, setEditorCode] = useState('');
	const [code, setCode] = useState('');
	const [sessionId, setSessionId] = useState('');
	const [startLab, setStartLab] = useState(true);
	const [loadingContainerStart, setLoadingContainerStart] = useState(false);
	const [substepCount, setSubstepCount] = useState(0);
	const [showCommand, setShowCommand] = useState(false)
	const [progress, setProgress] = useState(0);
	const [drawerOpen, setDrawerOpen] = useState(false);
	const [showFinishConfirm, setShowFinishConfirm] = useState(false);
	const [showReloadConfirm, setShowReloadConfirm] = useState(false);
	const [socketInstance, setSocketInstance] = useState(null);
	const [showContainerError, setShowContainerError] = useState(false);
	const roundedPercentage = nodeFinished ? 100 : Math.ceil(currentStep / nodeInfo?.numOfSteps * 100);
	const [maxUnlocked, setMaxUnlocked] = useState(0);
	const audioRef = useRef(null);
	const finalAudioRef = useRef(null);
	const viewContext = useContext(ViewContext)


	const activityTimerRef = useRef(null);

	useEffect(() => {
		setMaxUnlocked(prev => Math.max(prev, currentStep));
	}, [currentStep]);

	const startActivityTimer = () => {
		activityTimerRef.current = setTimeout(handleInactivity, 900000);
	};

	const resetActivityTimer = () => {
		clearTimeout(activityTimerRef.current);
		startActivityTimer();
	};

	function handleInactivity() {
		setShowReloadConfirm(true);
		handleContainerDelete();
	}

	const handleContainerDelete = () => {
		if (socketInstance) {
			socketInstance.disconnect();
		}

		const options = {
			method: 'DELETE',
			url: `/api/container-instances`,
			data: { sessionId },
			headers: {
				accept: 'application/json',
			}
		};

		axios
			.request(options)
			.then(async function (response) {
			})
			.catch((err) => {
				console.log(err)
			});

	};

	const handleRefresh = () => {
		window.location.reload();
	};

	const handleGoBack = () => {
		navigate(-1);
	};


	useEffect(() => {
		if (loadingContainerStart) {
			const interval = setInterval(() => {
				setProgress((prevProgress) => (prevProgress >= 95 ? 100 : prevProgress + 1.5));
			}, 1000);

			if (!loadingContainerStart) {
				clearInterval(interval);
			}
			return () => {
				clearInterval(interval);
			};
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [loadingContainerStart]);

	useEffect(() => {
		if (!steps) return;

		if (audioRef.current) {
			audioRef.current.pause();
		}

		const audioLink = steps[currentStep]?.voice;
		if (audioLink && !isMuted) {
			const newAudio = new Audio(audioLink);
			audioRef.current = newAudio;
			newAudio.play();
		}

		return () => {
			if (audioRef.current) {
				audioRef.current.pause();
			}
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currentStep, isMuted]);

	useEffect(() => {
		if (!nodeFinished) return;

		if (audioRef.current) {
			audioRef.current.pause();
		}

		const audio = new Audio(finalAudio);
		finalAudioRef.current = audio;
		audio.play();

		viewContext.notification.show(
			props.t('Labs.Nodes.NodeEditorTerminal.end'),
			'info',
			false
		);

		return () => {
			if (finalAudioRef.current) {
				finalAudioRef.current.pause();
			}
		};

	}, [nodeFinished])

	useEffect(() => {
		if (data) {
			const jsonData = decoder(data);
			jsonData.numofSteps = jsonData.steps.steps.length;

			setNodeInfo(jsonData);
			setSteps(jsonData.steps.steps)
			if (jsonData.steps.steps[currentStep]?.fileTree) {
				setWatcherData(jsonData.steps.steps[currentStep]?.fileTree)
			}
			document.title = props.t('Labs.Nodes.NodeEditorTerminal.title', { nodeName: jsonData.name });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [data]);

	useEffect(() => {
		if (userInput !== '') {
			validateInput();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [userInput]);

	function handleVoiceClick() {
		resetActivityTimer();
		setIsMuted(!isMuted)
	}

	function getCode(value) {
		resetActivityTimer();
		setEditorCode(value);
		setCode(value);
	}

	function moveToError(element) {
		const wastedAttemptAudio = new Audio(failedAttemptSound);
		wastedAttemptAudio.play();
		toast.dark(props.t('Labs.Nodes.NodeEditorTerminal.toast.error', { element: element }), {
			type: 'error',
			position: 'top-right',
			autoClose: 3000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
		});
	}

	function validateScript() {
		const exp = quote(steps[currentStep].exp_script.replace(/[\r\n\t\s]/g, ' ').split(' '));
		const user = quote(editorCode.replace(/[\r\n\t\s]/g, ' ').split(' '));

		const parse_user = parse(user);
		const parse_exp = parse(exp);

		const isValid = _.isEqual(parse_user, parse_exp);

		if ('exp_command' in steps[currentStep]) {
			if (isValid) {
				setShowCommand(true)
				return isValid;
			} else {
				moveToError("script");
				return;
			}
		}

		if (isValid) {
			setCurrentStep(currentStep + 1);
			setCode(steps[currentStep].template_code);
		} else {
			moveToError("script");
		}

	}

	function validateCommand() {
		setUserInput("")
		if ('exp_script' in steps[currentStep]) {
			const valid_script = validateScript();
			if (!valid_script) {
				return false;
			}
		}
		if (userInput) {
			if (nodeInfo?.array_flag) {

				if (steps) {
					const current = steps[currentStep].exp_command;
					const len = current.length;
					const current_regex = new RegExp(current[substepCount]);
					if (current_regex.test(userInput.trim()) && userInput) {
						setSubstepCount(substepCount + 1);
						if (len === substepCount + 1) {
							// call function to pass to next step
							if (currentStep !== nodeInfo.numofSteps - 1) {
								setCurrentStep(currentStep + 1);
								"template_code" in steps[currentStep + 1] ? setCode(steps[currentStep + 1].template_code) : setCode('');
								var myElement = document.getElementById('currenttimelineHolder');
								var topPos = myElement.offsetTop;
								document.getElementById('timelinescrolldiv').scrollTop = topPos;
								setSubstepCount(0);
								setShowCommand(false)
								if (steps[currentStep]?.fileTree) {
									setWatcherData(steps[currentStep]?.fileTree)
								}
							} else {
								setNodeFinished(true);
							}
						}
					} else {
						// call function to report the error
						moveToError("command");
					}
				}
			}
		}
	}

	function validateCode() {
		const parser = new Python3Parser();
		try {

			const userCodeTokens = parser.getAllTokens(editorCode + '\r\n');
			const userTokensArray = userCodeTokens
				.map((obj) => obj['text'])
				.filter((text) => text.trim() !== '' && text !== '\r\n');

			// Tokenizing expected code and creating an array of tokens only.
			const expectedTokens = parser.getAllTokens(steps[currentStep].exp_code + '\r\n');
			const expectedTokensArray = expectedTokens
				.map((obj) => obj['text'])
				.filter((text) => text.trim() !== '' && text !== '\r\n');

			if (_.isEqual(expectedTokensArray, userTokensArray)) {
				"template_code" in steps[currentStep + 1] ? setCode(steps[currentStep + 1].template_code) : setCode('');

				setCurrentStep(currentStep + 1);
				if (steps[currentStep]?.fileTree) {
					setWatcherData(steps[currentStep]?.fileTree)
				}

			} else {
				toast.dark(props.t('Labs.Nodes.NodeEditorTerminal.toast.warning'), {
					type: 'error',
					position: 'top-right',
					autoClose: 3000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
				});
			}
		} catch (error) {
			toast.dark(error, {
				type: 'error',
				position: 'top-right',
				autoClose: 3000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
			});
		}
	}

	const handleNext = () => {
		const formData = {
			sessionId: sessionId,
		};
		const options = {
			method: 'POST',
			url: `/api/user/labs/${lab_id}/nodes/${node_id}/end`,
			headers: {
				accept: 'application/json',
			},
			data: {
				...formData,
				...(nodeInfo.is_assessment === 1 && { completionPercent: roundedPercentage }),
			},
		};

		axios
			.request(options)
			.then(async function (response) {
				await new Promise((resolve) => setTimeout(resolve, 50)); // Adding a wait for api post to happen
				if (nodeInfo.is_assessment === 1) {
					navigate(`/labs/${lab_id}/nodes`);
				} else {
					navigate(`/labs/${lab_id}/nodes/${node_id}/quiz/attempt`);
				}
			})
			.catch((err) => {
				navigate('/oops');
			});
	};
	const startLabClick = async () => {
		startActivityTimer();
		setLoadingContainerStart(!loadingContainerStart);
		const formData = {
			resource: nodeInfo.resource,
		};
		const options = {
			method: 'POST',
			url: `/api/user/labs/${lab_id}/nodes/${node_id}/start`,
			headers: {
				accept: 'application/json',
			},
			data: formData,
		};
		await axios
			.request(options)
			.then((response) => {
				new Promise((resolve) => setTimeout(resolve, 100));
				const socket = createSocketConnection(
					process.env.REACT_APP_RELAY_URL,
					context.user?.token,
					() => { setShowContainerError(true) }
				);
				setSocketInstance(socket);
				setLoadingContainerStart(false);
				setStartLab(false);
				setSessionId(response.data.session_id);
				if (context?.user?.stop_walkthrough?.includes(nodeInfo?.resource?.lab_resource_id) || nodeInfo.is_assessment === 1) {
					setIsMuted(!isMuted)
				}
			})
			.catch((err) => {
				if (err.response.status === 403) {
					navigate('/nopermission');
				} else {
					navigate('/oops');
				}
			});
	};

	const navigateBack = () => {
		navigate(-1);
	};


	function validateInput() {
		resetActivityTimer();

		if (steps) {
			if ('exp_command' in steps[currentStep] && 'exp_script' in steps[currentStep]) {
				validateCommand();
			} else if ('exp_command' in steps[currentStep]) {
				validateCommand();
			} else if ('exp_script' in steps[currentStep]) {
				validateScript();
			} else if ('exp_code' in steps[currentStep]) {
				validateCode();
			}
			if (steps[currentStep].clear === 'true' && currentStep < nodeInfo.numofSteps - 1) {

				"template_code" in steps[currentStep + 1] ? setCode(steps[currentStep + 1].template_code) : setCode('');
			}
		}
	}

	const handleCopy = async () => {
		try {
			await navigator.clipboard.writeText(steps[currentStep].command);
		} catch {
			alert(props.t('Labs.Nodes.NodeEditorTerminal.alert'));
		}
	};

	const handleDrawer = () => {
		resetActivityTimer();
		setDrawerOpen(!drawerOpen);
	}

	const resetWalkthrough = (data) => {
		if (data.status === 'finished' | data.action === 'skip' | data.action === 'tour:end') {
			setIsMuted(!isMuted)
		}
	}
	useEffect(() => {
		const resourceIncluded = context?.user?.stop_walkthrough?.includes(nodeInfo?.resource?.lab_resource_id);
		if (resourceIncluded && !startLab) {
			setIsMuted(!isMuted)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [context?.user?.stop_walkthrough])

	// Cleanup on unmount
	useEffect(() => {
		return () => {
			cleanupSocket();
		};
	}, []);

	useEffect(() => {
		if (socketInstance) {
			socketInstance.on('disconnect', (reason) => {
				// Show reconnection message to user
				toast.dark('Connection lost. Attempting to reconnect...', {
					type: 'warning',
					position: 'top-right',
					autoClose: 3000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
				});

				if (reason === 'io server disconnect') {
					socketInstance.connect();
				}
			});

			socketInstance.on('reconnect', () => {
				toast.success('Reconnected successfully!');
			});

			socketInstance.on('connect_error', () => {
				toast.dark('Failed to reconnect. Please refresh the page.', {
					type: 'error',
					position: 'top-right',
					autoClose: 3000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
				});
			});
		}

		return () => {
			if (socketInstance) {
				socketInstance.off('disconnect');
				socketInstance.off('reconnect');
				socketInstance.off('connect_error');
			}
		};
	}, [socketInstance]);

	const sendHeartbeat = () => {
		const formData = {
			node_id: node_id,
		};
		const options = {
			method: 'POST',
			url: `/api/container-instances/heartbeat`,
			headers: {
				accept: 'application/json',
			},
			data: formData,
		};

		axios
			.request(options)
			.then(function (response) {
				// navigate(`/`);
			})
			.catch((err) => {
				console.log(err.response.status);
			});
	};

	useEffect(() => {
		//send heartbeat call every 4 mins
		const heartBeatId = setInterval(sendHeartbeat, 240000);

		return () => {
			clearInterval(heartBeatId);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const showConfirm = () => {
		setShowFinishConfirm(true);
	}

	const handleConfirmClick = () => {
		handleNext();
	}

	return (
		<>
			{/* container loading animation */}
			<Backdrop
				sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
				open={loadingContainerStart}
			>
				{!startLab && nodeInfo.is_assessment !== 1 ?
					<Joyride
						open={nodeInfo?.resource?.walkthrough?.open}
						run={nodeInfo?.resource?.walkthrough?.run}
						steps={nodeInfo?.resource?.walkthrough?.steps || []}
						resourceId={nodeInfo?.resource?.lab_resource_id}
						disableOverlay={true}
						callback={resetWalkthrough}
					/>
					: null}
				<div id="loadingAnimations" className={Styles.loadingAnimations}>
					<div style={{ display: 'flex', alignItems: 'center', justifyItems: 'center' }}>
						<ViewInArIcon fontSize="large" sx={{ fontSize: '60px' }} />
					</div>
					<div style={{ display: 'flex', alignItems: 'center', justifyItems: 'center', width: '100%' }}>
						<p id="loadingText" className={Styles.loadingText}></p>
					</div>
					<Box sx={{ width: '20rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
						<LinearProgress variant="determinate" value={progress} sx={{ minWidth: '95%' }} />
						<Typography variant="body2" color="white" sx={{ marginLeft: 2 }}>
							{`${progress}%`}
						</Typography>
					</Box>
				</div>
			</Backdrop>
			{loading ? (
				<div>
					<LoadingBackdrop isOpen={true} />
				</div>
			) : steps ? (
				<>
					<ToastContainer
						id="warning-toast"
						position="top-right"
						autoClose={10000}
						hideProgressBar={false}
						newestOnTop
						closeOnClick
						pauseOnFocusLoss
						draggable
						pauseOnHover
						limit={4}
					/>
					<ConfirmationCard
						title={props.t("Labs.Nodes.NodeEditorTerminal.confirm.timeout.title")}
						body={props.t("Labs.Nodes.NodeEditorTerminal.confirm.timeout.body")}
						showCard={showReloadConfirm}
						setShowCard={setShowReloadConfirm}
						handleCancel={handleGoBack} // Pass the refresh handler
						handleConfirm={handleRefresh} // Pass the go back handler
						confirmButtonText={props.t('Labs.Nodes.NodeEditorTerminal.confirm.button.refresh')}
						cancelButtonText={props.t('Labs.Nodes.NodeEditorTerminal.confirm.button.goBack')}
					/>
					<ConfirmationCard
						title={nodeInfo.is_assessment ? props.t('Labs.Nodes.NodeEditorTerminal.confirm.start.title.assessment') : props.t('Labs.Nodes.NodeEditorTerminal.confirm.start.title.default')}
						body={props.t('Labs.Nodes.NodeEditorTerminal.confirm.start.body')}
						showCard={startLab}
						setShowCard={setStartLab}
						handleCancel={navigateBack}
						handleConfirm={startLabClick}
					/>
					<ConfirmationCard
						title={props.t('Labs.Nodes.NodeEditorTerminal.error.connection.title')}
						body={props.t('Labs.Nodes.NodeEditorTerminal.error.connection.body')}
						showCard={showContainerError}
						setShowCard={setShowContainerError}
						handleCancel={navigateBack}
						handleConfirm={handleRefresh}
						confirmButtonText={props.t('Labs.Nodes.NodeEditorTerminal.confirm.button.refresh')}
						cancelButtonText={props.t('Labs.Nodes.NodeEditorTerminal.confirm.button.goBack')}
					/>
					<BackConfirmationCard
						isSaveAvailable={false}
						isContainerLab={true}
						sessionId={sessionId}
					/>
					<div id="ancestorContainer" className={Styles.ancestorContainer}>
						<div id="titleContainer" className={Styles.titleContainer}>
							<span style={{ display: 'flex' }}>
								<Avatar
									sx={{
										bgcolor: pink[500],
										alignSelf: 'center',
										mr: 1,
										width: 55,
										height: 55,
									}}
								>
									<TerminalIcon sx={{ width: 42, height: 42 }} />
								</Avatar>
								<Typography
									variant="h3"
									sx={{
										textTransform: 'uppercase',
										color: '#FFFFFF',
									}}
								>
									{nodeInfo.name}
								</Typography>
							</span>
							<div id="finishButtonContainer" className={Styles.finishButtonContainer}>
								<span style={{ display: 'flex', flexDirection: 'row' }}>
									<LightTooltip
										title={nodeFinished ?
											props.t('Labs.Nodes.NodeEditorTerminal.tooltip.finish.node') :
											props.t('Labs.Nodes.NodeEditorTerminal.tooltip.finish.assessment')}
										arrow
										placement="left"
										classes={{
											tooltip: {
												backgroundColor: '#fff',
												color: 'rgba(0, 0, 0, 0.87)',
												boxShadow: '0 2px 5px rgba(0, 0, 0, 0.15)',
												fontSize: 11,
											},
										}}
									>
										<span>
											<button
												variant="extended"
												className={Styles.finishButton}
												onClick={() => {
													nodeInfo.is_assessment ? showConfirm() : handleNext()
												}}
												disabled={
													!nodeInfo.is_assessment
														? !nodeFinished
														: roundedPercentage < 70
												}
											>
												<KeyboardDoubleArrowRightIcon />
												{props.t('Labs.Nodes.NodeEditorTerminal.button.finish')}
												{/* FINISH */}
											</button>
										</span>
									</LightTooltip>
									<ConfirmationCard
										title={props.t('Labs.Nodes.NodeEditorTerminal.confirm.completed.title')}
										body={props.t('Labs.Nodes.NodeEditorTerminal.confirm.completed.body')}
										showCard={showFinishConfirm}
										setShowCard={setShowFinishConfirm}
										handleConfirm={handleConfirmClick}
									/>
								</span>

								<div id="infoDrawer" className={Styles.fabContainer} onClick={handleDrawer}>
									<LightTooltip
										title={props.t('Labs.Nodes.NodeEditorTerminal.tooltip.reference')}
										arrow
										placement="left"
										classes={{
											tooltip: {
												backgroundColor: '#fff',
												color: 'rgba(0, 0, 0, 0.87)',
												boxShadow: '0 2px 5px rgba(0, 0, 0, 0.15)',
												fontSize: 11,
											},
										}}
									>
										<Fab color="primary" size="medium">
											<LightbulbIcon />
										</Fab>
									</LightTooltip>
								</div>
							</div>
						</div>

						<div>
							<div id="midContainer" className={NodeAutomationStyles.midContainer}>
								<div className={NodeAutomationStyles.editorSide}>
									<FolderOpenIcon
										id='fileTree'
										onClick={() => { setIsDrawerOpen(!isDrawerOpen); }}
										className={Styles.folderBtn}
										sx={{ fontSize: '4vh', }}
									/>

								</div>
								<div id="editorContainer" className={CodeEditorStyles.editorContainer} style={{ marginTop: '-15px', }}>
									<div
										id="editorWindow"
										style={{
											borderRadius: '8px',
											padding: '2px',
											// backgroundColor: 'white',
											height: '98vh',
											display: "flex",
											flexDirection: "column-reverse",
											justifyContent: "space-between"
										}}
										onClick={() => { isDrawerOpen ? setIsDrawerOpen(!isDrawerOpen) : setIsDrawerOpen(isDrawerOpen) }}
									>
										<div className={Styles.folderStructure}
											style={{
												marginTop: "-2px"
											}}
										>
											<div
												className={Styles.treeContainer}
												hidden={!isDrawerOpen}
												style={{
													marginTop: "17px",
													// borderRadius: "8px",

												}}
											>
												<RenderFolderTree data={watcherData} />
											</div>
											<div
												className={Styles.backDrop}
												hidden={!isDrawerOpen}
												style={{
													marginTop: "17px",
													borderTopRightRadius: "8px"
												}}
											>

											</div>
										</div>
										<div style={{ backgroundColor: 'white', width: 'fit-content', height: 'fit-content', padding: '9px', borderRadius: '8px', marginTop: 'px' }}>
											<MonacoEditor
												defaultValue={"template_code" in steps[currentStep] ? steps[currentStep].template_code : " "}
												value={code}
												width="45vw"
												height="87vh"
												theme="vs-light"
												defaultLanguage="python"
												onChange={getCode}
												options={{
													minimap: {
														enabled: false,
													},
													scrollbar: {
														vertical: 'hidden',
														alwaysConsumeMouseWheel: false,
													},
													fontSize: 16,
													wordWrap: 'on',
													glyphMargin: false,
													folding: false,
													lineDecorationsWidth: 10,
													lineNumbersMinChars: 2,
													glyphMarginDecorationLaneCount: 0,
												}}
											/>
										</div>
										<div id="buttonContainer" className={NodeAutomationStyles.bottomLeft}>
											<button id="runButton" className={NodeAutomationStyles.ButtonStyles} onClick={validateInput}>
												<>
													<InfoIcon /> {props.t('Labs.Nodes.NodeEditorTerminal.button.validate')}
												</>
											</button>
										</div>
									</div>
								</div>

								<div id="infoContainer" className={Styles.infoContainer}>
									<div id="instructionsContainer" className={Styles.instructionsContainer}>
										<div>
											<span style={{ width: '100%' }}>
												<button className={NodeAutomationStyles.muteBtn} onClick={handleVoiceClick}>
													{isMuted ? <VolumeOffIcon fontSize="small" /> : <VolumeUpIcon fontSize="small" />}
												</button>
												<p>{steps[currentStep]?.instructions}</p>
											</span>

											{'command' in steps[currentStep] && (
												<div className={Styles.codeBlockContainer} onClick={handleCopy}>
													<CodeBlock
														text={steps[currentStep].command}
														language={'exp_code' in steps[currentStep] ? 'python' : 'bash'}
														showLineNumbers="true"
														theme={anOldHope}
													/>
												</div>
											)}
											{('executable' in steps[currentStep] && showCommand) && (
												<>
													<p style={{ marginTop: '10px', marginBottom: '5px' }}>Command:</p>
													<div id='codeBlock' className={Styles.codeBlockContainer} onClick={handleCopy}>
														<CodeBlock
															text={steps[currentStep].executable}
															language={'exp_code' in steps[currentStep] ? 'python' : 'bash'}
															showLineNumbers="true"
															theme={anOldHope}
														/>
													</div>
												</>
											)}
										</div>
									</div>

									<span id="codeEditorTimeLine" className={Styles.codeEditorTimeLine}>
										<NodeTimeline
											nodeFinished={nodeFinished}
											currentStep={currentStep}
											steps={steps}
											currentRef={currentRef}
											hideToolTip={false}
											collapsable={true}
											maxUnlocked={maxUnlocked}
										/>
									</span>
								</div>
							</div>
						</div>
					</div>
					<InfoDrawer
						handleDrawer={handleDrawer}
						drawerOpen={drawerOpen}
						titleText={props.t('Labs.Nodes.NodeEditorTerminal.reference', { LabName: nodeInfo.labName })}
						// {`${nodeInfo?.labName} reference`}
						displayData={nodeInfo?.content?.reference_data}
					/>
					<div id="terminalContainer" className={Styles.TerminalPane}>
						<TerminalPane socket={socketInstance} setUserInput={setUserInput} sessionId={sessionId} resetActivityTimer={resetActivityTimer} />
					</div>
					{(!nodeFinished && nodeInfo?.is_assessment !== 1 && nodeInfo?.resource?.config?.chatbotTopic) && (
						<HelperChat
							active={props.aiChat}
							topic={nodeInfo?.resource?.config?.chatbotTopic}
						/>
					)}
					{nodeFinished && <Feedback isInNode={true} nodeName={nodeInfo.name} labName={nodeInfo.labName} />}

				</>
			) : (
				<div>
					<LoadingBackdrop isOpen={true} />
				</div>
			)}
		</>
	);
};

export default NodeEditorTerminal;
